import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IUserMast } from "../../models/UserMast";
import { IBranchMastDropdown, ICompanyMastDropdown, IRolesDropdown, IUsersDropdown } from "../../models/IDropdown";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { EmptyUser } from "./EmptyUser";
import { JVMultiselect } from "../../shared/JVMultiselect";
import { JVDate } from "../../shared/JVDate";
import { MultiSelect } from "primereact/multiselect";
import { ILogin } from "../../models/Login";

const schema = yup.object({
    user_Employee_ID: yup.string().required("Employee Code Is Required").typeError("Employee Code Is Required"),
    user_Name: yup.string().required("UserName is required*").min(3),
    login_Name: yup.string().required("LoginName is required*").min(3),
    user_EmailID: yup.string().required("UserEmailID is required*").email(),
    branch_ID: yup.number().min(1, "BranchName is required*").required("BranchName is required*"),
    user_Status: yup.boolean().required("UserStatus is required*"),
    temp_Inactive: yup.boolean().required("UserStatus is required*"),
    login_Password: yup.string().required("loginPassword is required*").min(6).max(16),
    workFrom: yup.number().required("WorkFrom is required*"),
    date_Of_Joining: yup.date().required("Date is required*").typeError("Date is required*"),
    // iMap_Password: yup.string().required("IMap Password is required*").min(6),
    exclude_From_Report: yup.boolean().nullable(),
});

interface Iprops {
    singleData: IUserMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [selectedCompanies, setSelectedCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [selectedBranches, setSelectedBranches] = useState<Array<IBranchMastDropdown>>();
    const [selectedPocBranches, setSelectedPocBranches] = useState<Array<IBranchMastDropdown>>();
    const [roles, setRoles] = useState<Array<IRolesDropdown>>();
    const [selectedRoles, setSelectedRoles] = useState<Array<IRolesDropdown>>();
    const [loading, setLoading] = useState(false);
    const [selectedUser, setSelectedUser] = useState<Array<number | any | IUsersDropdown>>([]);
    const [user, setuser] = useState<Array<any>>();
    const [isEmployeeCodeVerified, setIsEmployeeCodeVerified] = useState(false);
    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IUserMast>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach((role) => {
        _roles.push(role.role_ID);
    });

    useEffect(() => {
        if (props.open && props.singleData.date_Of_Joining) {
            const dateOfJoining = props.singleData.date_Of_Joining.toString();
            if (dateOfJoining.includes('-')) {
                const dateParts = dateOfJoining.split("-");
                if (dateParts.length === 3) {
                    const year = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const day = Number(dateParts[2].split("T")[0]);
                    if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
                        let date = new Date(year, month, day);
                        props.singleData.date_Of_Joining = date;
                    }
                }
            }
        }
        reset(props.singleData);
        if (props.singleData.login_ID) {
            loadAssignedRoles(props.singleData.login_ID);
            loadLinkedUser(props.singleData.login_ID);

            loadAssignedBranches(props.singleData.login_ID);
            loadPocuserBranches(props.singleData.login_ID);
        } else {
            setSelectedRoles([]);
        }
    }, [props.singleData]);

    const loadBranches = async () => {
        const response = await Fetch("Dropdown/branches", "GET", null, null, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            setBranches(data);
        }
    }
    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/company", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            setCompanies(data);
        }
    }
    const loadRoles = async () => {
        const response = await Fetch("Dropdown/rolesForUsersUpdate", "GET", null, null, null);
        if (response) {
            const data: Array<IRolesDropdown> = await response.json();
            const _data: Array<IRolesDropdown> = [];
            data.forEach(d => {
                _data.push({ role_ID: d.role_ID, role_Name: d.role_Name });
            })
            setRoles(_data);
        }
    }
    const loadAssignedRoles = async (id: number) => {
        const response = await Fetch("Dropdown/assignedRoles", "GET", null, `login_id=${id}`, null);
        if (response) {
            const data: Array<IRolesDropdown> = await response.json();
            const _data: Array<IRolesDropdown> = [];
            data.forEach(d => {
                _data.push({ role_ID: d.role_ID, role_Name: d.role_Name });
            })
            setSelectedRoles(_data);
        }
    }
    const loadAssignedBranches = async (id: number) => {
        const response = await Fetch("Dropdown/assignedBranches", "GET", null, `login_id=${id}`, null);
        if (response) {
            const data: Array<Branches> = await response.json();
            const _branches = branches?.filter(branch => {
                let is_included: boolean = false;
                for (let i = 0; i < data.length; i++) {
                    if (branch.branch_ID === data[i].branch_ID) {
                        is_included = true;
                        break;
                    }
                }
                return is_included;
            });
            setSelectedBranches(_branches);
        }
    }

    const loadLinkedUser = async (id: number) => {
        const response = await Fetch("Dropdown/linked_user", "GET", null, `login_id=${id}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            const _users = (user || [])
                .filter(user => data.some(d => d.link_User_ID === user.login_ID))
                .map(user => user.login_ID); // Extract only login_IDs

            setSelectedUser(_users);
        }
    };

    const loadUsers = async () => {
        const response = await Fetch("Dropdown/getLinkingUserslist", "GET", null, null, null);
        if (response) {
            const data: Array<any> = await response.json();
            const _data: Array<any> = [];
            data.forEach(d => {
                _data.push({ login_ID: d.login_ID, user_Name: d.user_Name, user_EmailID: d.user_EmailID });
            });
            setuser(_data);
        }
    }

    const loadPocuserBranches = async (id: number) => {
        const response = await Fetch("Dropdown/assignedPocRecruiterBranches", "GET", null, `login_id=${id}`, null);
        if (response) {
            const data: Array<Branches> = await response.json();
            const _branches = branches?.filter(branch => {
                let is_included: boolean = false;
                for (let i = 0; i < data.length; i++) {
                    if (branch.branch_ID === data[i].branch_ID) {
                        is_included = true;
                        break;
                    }
                }
                return is_included;
            });
            setSelectedPocBranches(_branches);
        }
    }

    useEffect(() => {
        loadCompanies();
        loadBranches();
        loadRoles();
        loadUsers();
    }, []);

    useEffect(() => {
        if (props.singleData.user_Employee_ID && props.singleData.user_Employee_ID !== null && props.singleData.user_Employee_ID.trim() !== "") {
            setIsEmployeeCodeVerified(true);
        }
    }, [props.singleData]);

    useEffect(() => {
        if (selectedCompanies) {
            const _selectedBranches = branches?.filter(branch => {
                let is_included: boolean = false;
                for (let i = 0; i < selectedCompanies.length; i++) {
                    if (branch.branchName.includes(selectedCompanies[i].company_Name)) {
                        is_included = true;
                        break;
                    }
                }
                return is_included;
            });
            setSelectedBranches(_selectedBranches);
        } else setSelectedBranches(undefined);
    }, [selectedCompanies]);

    interface Roles {
        role_ID: number
    }
    interface Branches {
        branch_ID: number
    }
    interface PocBranches {
        branch_ID: number
    }
    interface Link_User_IDs {
        login_ID: number
    }
    const saveToDB = async (body: IUserMast) => {
        const method = props.singleData.login_ID ? "PUT" : "POST";
        const message = props.singleData.login_ID ? "Updated Successfully" : "Added Successfully";
        const _roles: Array<Roles> = [];
        selectedRoles?.forEach(role => {
            _roles.push({ role_ID: role.role_ID });
        });
        const _branches: Array<Branches> = [];
        selectedBranches?.forEach(branch => {
            _branches.push({ branch_ID: branch.branch_ID });
        });

        const _pocBranches: Array<PocBranches> = [];
        selectedPocBranches?.forEach(branch => {
            _pocBranches.push({ branch_ID: branch.branch_ID });
        });
        const _link_User: Array<Link_User_IDs> = selectedUser?.map(login_ID => ({ login_ID })) || [];

        let query: null | string = null;
        if (_roles.length > 0) query = "roles=" + JSON.stringify(_roles);

        if (query === null) {
            props.toast.current.show({ severity: 'error', detail: "Select at least one Role", life: 3000 });
        } else {
            if (_branches.length > 0) query = query + "&branches=" + JSON.stringify(_branches);
            if (_pocBranches.length > 0) query = query + "&pocbranches=" + JSON.stringify(_pocBranches);
            if (_link_User.length > 0) query = query + "&linkUser=" + JSON.stringify(_link_User);
            if (props.singleData.branch_ID !== body.branch_ID) query = query + `&prevVranchID=${props.singleData.branch_ID}`;

            const response = await Fetch("User_Mast", method, body, query, props.toast);
            if (response) {
                onHide();
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                props.setReload(!props.reload);
            }
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyUser);
        setSelectedRoles(undefined);
        setSelectedBranches(undefined);
        setSelectedCompanies(undefined);
        setSelectedPocBranches(undefined);
        setSelectedUser([]);
    }

    function onSubmit(data: any) {

        if (isEmployeeCodeVerified === false) {
            props.toast.current.show({ severity: 'error', detail: "Please Verify Employee Code is available or not by clicking on search", life: 3000 });
        } else if (selectedBranches?.length == 0 || selectedBranches?.length == null) {
            props.toast.current.show({ severity: 'error', detail: "Please Select atleast one Branches", life: 3000 });
        }
        else if (selectedRoles && selectedRoles.some(role => role.role_Name === "Recruitment Head") && (selectedPocBranches?.length == 0 || selectedPocBranches?.length == null)) {
            props.toast.current.show({ severity: 'error', detail: "Please Select atleast one approve Poc Branch", life: 3000 });
        }
        else {
            if (isEmployeeCodeVerified === true) {
                saveToDB(data);
            } else if (isEmployeeCodeVerified === false && (props.singleData.user_Employee_ID)) {
                saveToDB(data);
            } else {
                props.toast.current.show({ severity: 'error', detail: "Employee Code Not Found", life: 3000 });
            }
        }
    }

    const searchEmployeeCode = async () => {
        if (control._formValues.user_Employee_ID) {
            const response = await Fetch("User_Mast/findEmployeeCode", "GET", null, `code=${control._formValues.user_Employee_ID}`, props.toast);
            if (response) {
                const data: any = await response.json();
                setIsEmployeeCodeVerified(true);
                props.toast.current.show({ severity: 'success', detail: ("Employee Code Found For : " + data.employee_Name), life: 3000 });
            } else {
                setIsEmployeeCodeVerified(false);
            }
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "user_Employee_ID") {
                if (value.user_Employee_ID !== null && value.user_Employee_ID !== undefined && value.user_Employee_ID.trim() !== "") {
                    setIsEmployeeCodeVerified(false);
                }
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit User" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                {props.singleData.user_Employee_ID && loginObj.id !== 1 && <div className='field col-12 md:col-6'>
                    <label>Employee Code</label>
                    <p className="border-1 border-round border-400 pl-2 pt-2" style={{ height: "34px" }}>{props.singleData.user_Employee_ID}</p>
                </div>}
                {(!props.singleData.user_Employee_ID || loginObj.id === 1) && (_roles.includes(1) || _roles.includes(26) || _roles.includes(13) || _roles.includes(51)) &&
                    <div className="field col-12 md:col-6 flex" style={{ marginLeft: "-1rem" }}>
                        <JVInput required label="Employee Code" control={control} name="user_Employee_ID" error={errors.user_Employee_ID?.message} />
                        <Button style={{ width: "2rem", height: "32px", marginTop: "2rem" }} icon="pi pi-search" type="button" onClick={() => searchEmployeeCode()} />
                    </div>}
                <JVInput required label="Name" control={control} name="user_Name" error={errors.user_Name?.message} />
                <JVInput required label="Email" control={control} name="user_EmailID" error={errors.user_EmailID?.message} />
                <JVInput required label="LoginID" control={control} name="login_Name" error={errors.login_Name?.message} />
                <JVInput required label="Password" control={control} name="login_Password" error={errors.login_Password?.message} />
                <JVInput label="IMAP Password" control={control} name="iMap_Password" />
                <JVDropdown required label="Branch Name" control={control} name="branch_ID" error={errors.branch_ID?.message} options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />
                <JVDropdown required label="Work From" control={control} name="workFrom" error={errors.workFrom?.message}
                    options={[{ id: 1, name: "Onsite" }, { id: 2, name: "Remote" }]} optionLabel="name" optionValue="id" placeholder="Select Work From" />
                <JVDate label="Date Of Joining" required control={control} name="date_Of_Joining" error={errors.date_Of_Joining?.message} />
                <JVMultiselect label="Assign Roles" options={roles} optionLabel="role_Name" placeholder="Select Roles" required value={selectedRoles} onChange={setSelectedRoles} />
                <JVMultiselect label="Assign Companies" options={companies} optionLabel="company_Name" placeholder="Select Companies" value={selectedCompanies} onChange={setSelectedCompanies} />
                <JVMultiselect required label="Assign Branches" options={branches} optionLabel="branchName" placeholder="Select Branches" value={selectedBranches} onChange={setSelectedBranches} />
                {selectedRoles && selectedRoles.some(role => role.role_Name === "Recruitment Head") && <JVMultiselect required label="Approve Poc Requirements" options={branches} optionLabel="branchName" placeholder="Select Branches" value={selectedPocBranches} onChange={setSelectedPocBranches} />}
                <JVCheckbox column={4} required label="Status" control={control} name="user_Status" />
                <JVCheckbox column={4} required label="Temp Inactive" control={control} name="temp_Inactive" />
                <JVCheckbox column={2} label="Exclude From Report" control={control} name="exclude_From_Report" />
                <div style={{ width: '48%', marginBottom: '20px' }} >
                    <label className="ml-1 mb-2" style={{ display: 'block', marginBottom: '12px' }}>Select User<small className="p-error" ></small></label>
                    <MultiSelect
                        value={selectedUser}
                        onChange={(e) => setSelectedUser(e.value)}
                        options={user}
                        optionLabel="user_Name"
                        optionValue="login_ID"
                        display="chip"
                        filter
                        filterBy="user_Name,user_EmailID"
                        showClear
                        placeholder="Select users"
                    />
                </div>

                <div className="col-12 md:col-12">
                    <Button className="field col-12 md:col-6" loading={loading} label="SAVE" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}